import { FormFieldsCategory, FormValues } from 'theSource/types';
import { mapFormValues } from 'theSource/utils';
import { SubscriberEditRequestDto } from '../types';

export const mapSubscriberEditDto = (
  categories: FormFieldsCategory[],
  values: FormValues
): SubscriberEditRequestDto => {
  const data = mapFormValues(categories, values);

  return {
    subscriber: data,
  };
};
